<template>
    <lasting-dosage-form v-if="subFormIsLastingDosage" v-model="internalValue" :formulation-and-route="formulationAndRoute" />
    <dosage-repeat-form v-else-if="subFormIsDosageRepeat" v-model="internalValue" :formulation-and-route="formulationAndRoute" />
</template>

<script lang="ts">
import { computed, defineComponent, PropType, ref, watch } from 'vue';
import { FormulationAndRouteFull } from '@/service/models/response/drug-model-detail/formulation-and-route-full';
import { LastingDosageVM } from '@/service/view-models/dosage-choices/lasting-dosage-vm';
import { BaseDosageChoiceVM } from '@/service/view-models/dosage-choices/base-dosage-choice-vm';
import { DosageRepeatVM } from '@/service/view-models/dosage-choices/dosage-repeat-vm';
import DosageRepeatForm from './DosageRepeatForm.vue';
import LastingDosageForm from './LastingDosageForm.vue';

export default defineComponent({
    components: {
        DosageRepeatForm,
        LastingDosageForm,
    },

    props: {
        modelValue: {
            type: Object as PropType<BaseDosageChoiceVM>,
            required: true,
        },

        formulationAndRoute: {
            type: Object as PropType<FormulationAndRouteFull>,
            required: true,
        },
    },

    emits: {
        "update:modelValue": (payload: BaseDosageChoiceVM) => typeof payload === "object",
    },

    setup(props, {emit})
    {
        const internalValue = ref(props.modelValue);

        // Sync external model with internal value
        watch(() => props.modelValue, (newValue) => {
            internalValue.value = newValue;
        });
        watch(internalValue, () => {
            emit("update:modelValue", internalValue.value);
        })

        const subFormIsLastingDosage = computed(() => props.modelValue instanceof LastingDosageVM);
        const subFormIsDosageRepeat = computed(() => props.modelValue instanceof DosageRepeatVM);

        return {
            internalValue,

            subFormIsLastingDosage,
            subFormIsDosageRepeat,
        };
    }
});
</script>
